export function isAnAddVariable(erlangTypeID, expression){
    if (erlangTypeID === 171  || erlangTypeID === 166){
      return true;
    }else if (erlangTypeID === 117){
      if (expression.t === "tuple"){
        if (expression.v[0].v === "k"){
          if (expression.v[1].v === 175){
            return true;
          }
        }
      }
    }else{
      return false;
    }
}
export function isValidVariableOrReusable(erlangTypeID, expression){
      if (erlangTypeID === 137 || erlangTypeID === 22 ){
        return false;
      }else if (isAnAddVariable(erlangTypeID, expression)){
        return false;
      }
      return true;
  }

export function getSubtitleFromLabels(index, labels){
  if (index < labels.length){
    return labels[index].v;
  }else if (labels.length > 0){
    return labels[labels.length - 1].v;
  }else{
    return "";
  }
}

export function getInteractionType(tree){
  var erlangTypeID = tree.v[0].v;
  if (erlangTypeID === 15 || erlangTypeID === 26){
    return 2;
  }
  var expression = tree.v[8];
  if (expression.t === "tuple"){
    if (expression.v[0].v === "k"){
      if (expression.v[1].v === 65){
        return 2;
      }
    }
  }
  return 0;
}
